import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import ConsultRequestRow from '../ConsultRequestRow/ConsultRequestRow';
import './ConsultRequestTable.css';
import { useTranslation } from 'react-i18next';
import React from 'react';
import ExploreRules from '../../../models/EquivalencyRuleActivity';
import { v4 as uuidv4 } from 'uuid';

interface ConsultRequestTableProps {
  rules: ExploreRules[]
}

const ConsultRequestTable:React.FC<ConsultRequestTableProps> = ({ rules }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography
        color="primary"
        variant="h5"
        fontWeight="500"
        style={{ margin: '10px 0', fontSize: '17px' }}
      >
        {t('equivalenciesTitle')}
      </Typography>
        <TableContainer sx={{maxHeight: 490}}>
          <Table key={rules.toString()} className="REQXXI-EquivalencyRule-Table" stickyHeader size="small" aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell className="REQXXI-ConsultRequestTable-ActivitiesTarget" align="left" scope="row">
                  <Typography> {t('sourceActivity')}</Typography>
                </TableCell>
                <TableCell className="REQXXI-ConsultRequestTable-ActivitiesSource" align="left">
                  <Typography> {t('targetActivity')}</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ overflow: 'auto' }}>
              {rules?.map((row) => (
                <ConsultRequestRow
                  key={uuidv4()}
                  row={row}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer >
        <Typography color="#544e4e" sx={{ fontSize: "14px", textAlign: "center" }}>
          {t("PossibleEquivalences")}
        </Typography>
    </>
  );
};

export default ConsultRequestTable;
